import { getSchema as getSchema1, uiSchema as uiSchema1, } from "./schema.createRentDeposit.1";
import { getSchema as getSchema2, getValidate as getValidate2, uiSchema as uiSchema2, } from "./schema.createRentDeposit.2";
import { getSchema as getSchema3, getValidate as getValidate3, uiSchema as uiSchema3, } from "./schema.createRentDeposit.3";
import { getSchema as getSchema5, uiSchema as uiSchema5, } from "./schema.createRentDeposit.5";
import { getSchema as getSchema6, uiSchema as uiSchema6, } from "./schema.createRentDeposit.6";
import { getSchema as getSchema7, getValidate as getValidate7, uiSchema as uiSchema7, } from "./schema.createRentDeposit.7";
import { getSchema as getSchema8, uiSchema as uiSchema8, getValidate as getValidate8, getPreSubmitAction as getPreSubmitAction8, } from "./schema.createRentDeposit.8";
import { getInitialValues, getIsShowMangopaySignersForm, getIsShowBanqupSignersForm, getIsShowMangopayIDForm, getIsShowBanqupIDForm, getTenants, showInsurance, } from "./schema.createRentDeposit.utils";
// eslint-disable-next-line import/no-default-export
export default (function (extraData) {
    var initialValues = getInitialValues(extraData);
    return [
        {
            schema: getSchema1(initialValues, extraData),
            uiSchema: uiSchema1(extraData),
        },
        {
            schema: getSchema2(initialValues, extraData),
            uiSchema: uiSchema2(extraData),
            validate: getValidate2(extraData),
            showIf: function (formData) {
                return getIsShowMangopaySignersForm(formData, extraData);
            },
        },
        {
            schema: getSchema3(initialValues, extraData),
            uiSchema: uiSchema3(extraData),
            validate: getValidate3(extraData),
            showIf: function (formData) {
                return getIsShowBanqupSignersForm(formData, extraData);
            },
        },
        {
            schema: getSchema6(initialValues, extraData),
            uiSchema: uiSchema6(extraData),
            showIf: function (formData) { return getTenants(formData, extraData).length > 1; },
        },
        {
            schema: getSchema5(initialValues, extraData),
            uiSchema: uiSchema5(extraData),
            showIf: function (formData) { return getIsShowMangopayIDForm(formData, extraData); },
        },
        {
            schema: getSchema8(initialValues, extraData),
            uiSchema: uiSchema8(extraData),
            validate: getValidate8(),
            preSubmitAction: getPreSubmitAction8(extraData),
            showIf: function (formData) { return getIsShowBanqupIDForm(formData, extraData); },
        },
        {
            schema: getSchema7(initialValues, extraData),
            uiSchema: uiSchema7(extraData),
            validate: getValidate7(extraData),
            showIf: function () { return showInsurance(extraData); },
        },
    ];
});
